import { render, staticRenderFns } from "./oneCompetence.vue?vue&type=template&id=58c8d392&scoped=true"
import script from "./oneCompetence.vue?vue&type=script&lang=js"
export * from "./oneCompetence.vue?vue&type=script&lang=js"
import style0 from "./oneCompetence.vue?vue&type=style&index=0&id=58c8d392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8d392",
  null
  
)

export default component.exports